import { AxiosResponse } from 'axios';

import { RoomI } from '../../declarations/interfaces/rooms';
import { get } from '../api';

export const getRoomTypes = async (customerId: string): Promise<AxiosResponse<RoomI[]>> =>
  await get(`/cfc/customers/${customerId}/room-types/localization`);
